export default "__VITE_ASSET__BL$cRk_S__"